import Card from 'components/card';
import { HiX } from 'react-icons/hi';

interface IVideoPreview {
  url: string;
  onClose: () => void;
}

const VideoPreview = ({ url, onClose }: IVideoPreview) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <Card className="relative bg-white rounded-xl p-8 shadow-xl max-w-2xl w-full">
        <button onClick={onClose} className="absolute top-2 right-2 text-gray-500 hover:text-black">
          <HiX />
        </button>
        <h2 className="text-lg font-bold mb-2">Video Preview</h2>
        <video src={url} controls autoPlay className="w-full h-auto max-h-[80vh] rounded" />
      </Card>
    </div>
  );
};

export default VideoPreview;
